// extracted by mini-css-extract-plugin
export default {"whiteLoader":"style_whiteLoader__aHoQN","loading":"style_loading__Hv95I"};